import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../contexts/SiteSettingsContext';

/**
 * SEOHead Component
 * Dynamically sets meta tags from site settings for SEO
 */
const SEOHead = () => {
  const { siteSettings } = useSiteSettings();

  const title = siteSettings?.meta_title || 'PEBDEQ - E-commerce';
  const description = siteSettings?.meta_description || 'Discover unique products at PEBDEQ';
  const keywords = siteSettings?.meta_keywords || '';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEOHead;



